module.exports = __webpack_public_path__ + "img/company_08.254b50a4.png";